export default __webpack_public_path__ + "static/media/ev-one.997bccb7.jpg";